import { Session } from "@talkjs/react";
import { ErrorBoundary } from "@themes/pollinator/ui/ErrorBoundary";
import { TalkJSData } from "@core/features/chat";

export type Props = {
  talkjsData: TalkJSData | null | undefined;
  children: React.ReactNode;
};

export function ChatSession({ talkjsData, children }: Props) {
  if (!talkjsData) {
    return children;
  }

  if (!talkjsData.app_id || !talkjsData.user_id || !talkjsData.token) {
    return children;
  }

  return (
    <ErrorBoundary fallback={<>{children}</>}>
      <Session
        appId={talkjsData.app_id}
        userId={talkjsData.user_id}
        token={talkjsData.token}
      >
        {children}
      </Session>
    </ErrorBoundary>
  );
}

export default ChatSession;


